import styled from "styled-components";
import CodeIcon from "@mui/icons-material/Code";
import AndroidIcon from "@mui/icons-material/Android";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import StorageIcon from "@mui/icons-material/Storage";

const MOHAMED_IMG = "/assets/images/mohamed.jpeg";

const isMohamed = (member) =>
  member?.name?.toLowerCase().includes("mohamed el makhfi") ||
  member?.img?.includes("mohamed");

const getProjectIcon = (category, tags = []) => {
  const tagStr = tags.join(" ").toLowerCase();
  if (category === "android app") return AndroidIcon;
  if (tagStr.includes("ai") || tagStr.includes("puter")) return AutoAwesomeIcon;
  if (tagStr.includes("spring") || tagStr.includes("mongodb") || tagStr.includes("mysql")) {
    return StorageIcon;
  }
  return CodeIcon;
};

const PhotoAvatar = styled.img`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  object-fit: cover;
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border: 3px solid ${({ theme }) => theme.card};
  flex-shrink: 0;

  @media (max-width: 600px) {
    width: ${({ $size }) => ($size > 40 ? 32 : $size)}px;
    height: ${({ $size }) => ($size > 40 ? 32 : $size)}px;
  }
`;

const IconAvatar = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.gradient};
  color: ${({ theme }) => theme.white};
  box-shadow: 0 0 12px ${({ theme }) => theme.glow};
  border: 3px solid ${({ theme }) => theme.card};
  flex-shrink: 0;

  svg {
    font-size: ${({ $size }) => Math.round($size * 0.48)}px;
  }

  @media (max-width: 600px) {
    width: ${({ $size }) => ($size > 40 ? 32 : $size)}px;
    height: ${({ $size }) => ($size > 40 ? 32 : $size)}px;

    svg {
      font-size: ${({ $size }) => ($size > 40 ? 16 : Math.round($size * 0.48))}px;
    }
  }
`;

const MemberAvatar = ({
  member,
  projectCategory = "web app",
  projectTags = [],
  size = 38,
  className,
  style,
}) => {
  if (isMohamed(member)) {
    return (
      <PhotoAvatar
        src={MOHAMED_IMG}
        alt={member.name}
        $size={size}
        className={className}
        style={style}
      />
    );
  }

  const Icon = getProjectIcon(projectCategory, projectTags);

  return (
    <IconAvatar $size={size} className={className} style={style} title={member.name}>
      <Icon />
    </IconAvatar>
  );
};

export default MemberAvatar;
